<div id="idMenuArbolWrapper" *ngIf="!answerDisplayed && !cargandoDatos" style="height: 100%">
  <div id="idMenuArbolInnerContent" class="card-body bg-white menu-inner-content"
    style="border-radius: 4px 4px 0px 0px">
    <app-enlace-back *ngIf="this.currentFather && this.currentFather.id !== 'ROOT'" (click)="loadParent()"
      [enlace_texto]="getTextoVolver()"></app-enlace-back>
    <!-- <app-enlace-back *ngIf="this.displayCurrentFatherOldMenu" (click)="loadParentOldMenu()" [enlace_texto]="
        this.temaCurrentFatherOldMenu
          ? 'Volver a ' + this.temaCurrentFatherOldMenu
          : 'Elegir otro tema de consulta 2'
      "></app-enlace-back> -->
    <div class="card-body-content" *ngIf="habilitado">
      <div id="divNodoPadreSelected" [attr.data-valor]="miValorVariablePadre" *ngIf="mostrarDiv"></div>
      <div id="divNodoSelected" [attr.data-valor]="miValorVariable" *ngIf="mostrarDiv"></div>

      <app-titulo-h1 [titulo]="
          this.currentFather && this.currentFather.name !== 'Raiz'
            ? this.currentFather.name
            : '¿Cómo puedo ayudarte?'
        "></app-titulo-h1>
      <ng-container *ngIf="currentFAQ.length > 0">
        <div class="contenedor-faqs">
          <app-titulo-h2 [titulo]="
              this.currentFather && this.currentFather.name !== 'Raiz'
                ? 'Lo más consultado'
                : 'Están consultando hoy...'
            "></app-titulo-h2>
          <ul class="list-pretty mt-3">
            <li *ngFor="let faqNode of currentFAQ">
              <app-nodo-arbol [node]="faqNode" [esFaq]="true"
                (displayAnswerEmitter)="displayAnswer($event)"></app-nodo-arbol>
            </li>
          </ul>
        </div>
      </ng-container>

      <div class="listado_con_tituloh2">
        <app-titulo-h2 [titulo]="
            this.currentFather && this.currentFather.name !== 'Raiz'
              ? null
              : 'Elegí un tema para consultar'
          "></app-titulo-h2>
        <h5 *ngIf="
            this.currentFather &&
            this.currentFather.name !== 'Raiz' &&
            currentFAQ.length > 0
          " class="font-weight-bold f-18">
          {{ "Elegí una opción" }}
        </h5>

        <div class="css-Listado_Items listado_items">
          <ng-container *ngFor="let node of displayedNodes">
            <app-nodo-arbol *ngIf="node.visible" [ctx]="ctx" [node]="node" [cantidadNodos]="cantidadNodos"
              [numberOfSiblingsArr]="numberOfSiblingsArr" [numberOfSiblingsArrCreation]="numberOfSiblingsArrCreation"
              [requiereAutenticacion]="
                ctx.esEntornoAnonimo &&
                node.requiereAutenticacion &&
                (node.type == 'CHAT' || node.type == 'FORMULARIO' || node.type == 'ACCION')
              " (displayAnswerEmitter)="displayAnswer($event)" (displayTramiteEmitter)="displayAnswerTramite($event)"
              (nodeEmitter)="seleccionarNodo($event)" (renderMenuArbolEmitter)="emitRenderMenuArbol($event)">
            </app-nodo-arbol>
          </ng-container>
        </div>
      </div>

      <br />
    </div>
    <div class="card-body-content" *ngIf="!habilitado && !ctx.errorCarga">
      <h4 class="titulo-principal mt-2 mb-4 f-22">
        No es posible visualizar el contenido del presente menú ya que se
        encuentra deshabilitado.
      </h4>
      <br />
    </div>
    <div class="card-body-content" *ngIf="ctx.errorCarga">
      <h4 class="titulo-principal mt-2 mb-4 f-22">
        {{this.ctx.mensajeErrorCarga}}
      </h4>
      <br />
    </div>
  </div>
</div>

<div *ngIf="answerDisplayed">
  <div class="card-body bg-white response-box" style="border-radius: 4px 4px 0px 0px">
    <app-enlace-back (click)="clearAnswerDisplayedNode()" [enlace_texto]="obtenerEtiquetaVolver()"></app-enlace-back>
    <div id="divNodoPadreSelected" [attr.data-valor]="miValorVariablePadre" *ngIf="mostrarDiv"></div>
    <div id="divNodoSelected" [attr.data-valor]="miValorVariable" *ngIf="mostrarDiv"></div>
    <div class="card-body-content-response" *ngIf="!this.displayTramite">
      <h4 class="titulo-principal mt-2 mb-4 f-22">{{ answerNode.name }}</h4>
      <div [innerHtml]="answerNode.answer"></div>
    </div>
    <div class="card-body-content-response" *ngIf="this.displayFormEmpresa && this.displayTramite">
      <h4 class="titulo-principal mt-2 mb-4 f-22">{{ answerNode.name }}</h4>
      <ng-container *ngIf="currentFAQ.length > 0">
        <div class="contenedor-faqs">
          <app-titulo-h2 [titulo]="
              this.currentFather && this.currentFather.name !== 'Raiz'
                ? 'Lo más consultado'
                : 'Están consultando hoy...'
            "></app-titulo-h2>
          <ul class="list-pretty mt-3">
            <li *ngFor="let faqNode of currentFAQ">
              <app-nodo-arbol [node]="faqNode" [esFaq]="true"
                (displayAnswerEmitter)="displayAnswer($event)"></app-nodo-arbol>
            </li>
          </ul>
        </div>
      </ng-container>
      <div>
        <app-canales-contacto style="padding-top:30px;" titulo="¿No resolvimos tu consulta?"
          [ir_a_tramite]="answerNode && answerNode.idContenido !== undefined" (ir_a_tramite_funcion)="irAlTramite()"
          [enviar_consulta]="
            (answerNode && answerNode.idDestinatario !== undefined) ||
            answerNode.assistanceId != undefined
          " (enviar_consulta_funcion)="cargarFormularioConsulta()" [requiereAutenticacion]="
            ctx.esEntornoAnonimo &&
            answerNode &&
            answerNode.requiereAutenticacion
          "></app-canales-contacto>
      </div>
    </div>
  </div>
</div>

<app-canales-contacto [enviar_consulta]="!this.displayTramite && this.displayForm && !ctx.errorCarga" [requiereAutenticacion]="
    ctx.esEntornoAnonimo &&
    ((answerNode &&
      answerNode.requiereAutenticacion &&
      (answerNode.type == 'PREGUNTA' || answerNode.type == 'RESPUESTA')) ||
      (currentFather &&
        currentFather.requiereAutenticacion &&
        (currentFather.type == 'PREGUNTA' ||
          currentFather.type == 'RESPUESTA')))
  " (enviar_consulta_funcion)="cargarFormularioConsulta()" [messenger]="displayMessenger"
       (messenger_funcion)="abrirMessenger()"></app-canales-contacto>

<app-error-pie [ctx]="this.ctx" [nodo]="this.currentFather" *ngIf="!this.ctx.errorCarga && this.ctx.codAsistenteError===undefined"
  (renderMenuArbolEmitter)="emitRenderMenuArbol($event)"></app-error-pie>

<div class="spinner-overlay" *ngIf="cargandoDatos">
  <div class="spinner-center">
    <mat-spinner diameter="80" color="primary"></mat-spinner>
    <label class="input-label" *ngIf="cargandoDatos">&nbsp; Cargando datos...</label>
  </div>
</div>


<div style="padding-bottom: 5px; padding-top: 5px;">
  <app-boton-secundario-consulta boton_texto="Volver al inicio"
    (boton_funcion)="returnToStart()"></app-boton-secundario-consulta>
</div>